import {
  login,
  UpdateInfo,
  getInfo,
  userList,
  enroll,
  verifyCode,
  forgetPassword,
  getFeedBackList,
  replyFeedback,
  getAdList,
  editAdvertise,
  addAdvertise,
  deleteAd,
  getTickets,
  searchGame,
  addTickets,
  deleteTicket,
  excel,
  getNotices,
  addNotice,
} from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { resetRouter } from "@/router";
import { ActionContext, Store } from "vuex";
import { ElMessage } from "element-plus";

const getDefaultState = (): State => {
  return {
    token: getToken(),
    name: "",
    avatar: "",
    Id: "",
    type: "",
    email: "",
    status: 0,
  };
};

const state: State = getDefaultState();

const mutations = {
  RESET_STATE(state: State) {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN(state: State, token: string) {
    state.token = token;
  },
  SET_NAME(state: State, name: string) {
    state.name = name;
  },
  SET_AVATAR(state: State, avatar: string) {
    state.avatar = avatar;
  },
  SET_TYPE(state: State, type: string) {
    state.type = type;
  },
  SET_ID(state: State, id: string) {
    state.Id = id;
  },
  SET_EMAIL(state: State, email: string) {
    state.email = email;
  },
  SET_STATUS(state: State, status: number) {
    state.status = status;
  },
};

const actions = {
  // user login
  login(
    { commit }: ActionContext<State, any>,
    userInfo: { username: string; password: string }
  ) {
    const { username, password } = userInfo;
    return new Promise<void>((resolve, reject) => {
      login({ username: username.trim(), password: password })
        .then((response: ApiResponse) => {
          const { data, jwt } = response;
          const { headPic, name, id, type, email, status } = data.userInfo;
          commit("SET_TOKEN", jwt);
          commit("SET_NAME", name);
          commit("SET_AVATAR", headPic);
          commit("SET_ID", id);
          commit("SET_TYPE", type);
          commit("SET_EMAIL", email);
          commit("SET_STATUS", status);
          setToken(jwt);
          resolve();
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  register(
    { commit }: ActionContext<State, any>,
    userInfo: {
      username: string;
      password: string;
      email: string;
      captcha: string;
    }
  ) {
    const { username, password, email, captcha } = userInfo;
    return new Promise<void>((resolve, reject) => {
      enroll(
        { username: username.trim(), password: password, email: email },
        { code: captcha }
      )
        .then((response: ApiResponse) => {
          const { data, jwt } = response;
          const { headPic, name, id, email, type, status } = data;

          commit("SET_TOKEN", jwt);
          commit("SET_NAME", name);
          commit("SET_AVATAR", headPic);
          commit("SET_ID", id);
          commit("SET_EMAIL", email);
          commit("SET_TYPE", type);
          commit("SET_STATUS", status);
          setToken(jwt);
          resolve();
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  GetEmailCode(
    { commit }: ActionContext<State, any>,
    { action, userName }: { action: string; userName: string }
  ) {
    return new Promise<void>((resolve, reject) => {
      verifyCode({ action: action, userName: userName })
        .then((response: ApiResponse) => {
          const { data } = response;
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  forgetPassword(
    { commit }: ActionContext<State, any>,
    {
      email,
      code,
      newPassword,
    }: { email: string; code: string; newPassword: string }
  ) {
    return new Promise<void>((resolve, reject) => {
      forgetPassword({ email: email, code: code, newPassword: newPassword })
        .then((response: ApiResponse) => {
          const { data } = response;

          if (data == 1) {
            ElMessage.success({
              message: "修改成功",
            });
          }
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit, state }: ActionContext<State, any>) {
    return new Promise((resolve, reject) => {
      getInfo(state.token as string)
        .then((response: ApiResponse) => {
          const { data } = response;

          const { name, avatar } = data;

          commit("SET_NAME", name);
          commit("SET_AVATAR", avatar);
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getUserList(
    { commit, state }: ActionContext<State, any>,
    userInfo: { pageNum: number; pageSize: number; status: number }
  ) {
    return new Promise((resolve, reject) => {
      userList(userInfo)
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  UpdateUser(
    { commit, state }: ActionContext<State, any>,
    userInfo: { name: string; password: string; headPic: string; type: string }
  ) {
    return new Promise((resolve, reject) => {
      const userId = state.Id;
      const updatedUserInfo = { ...userInfo, id: userId };
      UpdateInfo(updatedUserInfo)
        .then((response: ApiResponse) => {
          const { data } = response;

          const { name, headPic, type } = data;

          commit("SET_NAME", name);
          commit("SET_AVATAR", headPic);
          commit("SET_TYPE", type);
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getFeedbackList(
    { commit, state }: ActionContext<State, any>,
    params: { pageNum: number; pageSize: number }
  ) {
    return new Promise((resolve, reject) => {
      getFeedBackList(params)
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  replyFeedback(
    { commit, state }: ActionContext<State, any>,
    params: { id: string; email: string; content: string; question: string }
  ) {
    return new Promise((resolve, reject) => {
      replyFeedback(params)
        .then((response: ApiResponse) => {
          const { data } = response;
          if (response.code == 200) {
            ElMessage.success({
              message: "修改成功",
            });
          }
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getAdList(
    { commit, state }: ActionContext<State, any>,
    params: { pageNum: number; pageSize: number }
  ) {
    return new Promise((resolve, reject) => {
      getAdList(params)
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getTickets({ commit, state }: ActionContext<State, any>, params: {}) {
    return new Promise((resolve, reject) => {
      getTickets(params)
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  getNotices(
    { commit, state }: ActionContext<State, any>,
    params: { pageNum: number; pageSize: number }
  ) {
    return new Promise((resolve, reject) => {
      getNotices(params)
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  searchGame(
    { commit, state }: ActionContext<State, any>,
    params: { gameTitle: string }
  ) {
    return new Promise((resolve, reject) => {
      searchGame(params)
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  addTickets(
    { commit, state }: ActionContext<State, any>,
    { params, data }: { params: any; data: any }
  ) {
    return new Promise((resolve, reject) => {
      console.log(params);

      addTickets(params, data)
        .then((response: ApiResponse) => {
          const { data } = response;

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  deleteTicket(
    { commit }: ActionContext<State, any>,
    { params }: { params: any }
  ) {
    return new Promise((resolve, reject) => {
      deleteTicket(params)
        .then((response: ApiResponse) => {
          const { data } = response;
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  exportExcel(
    { commit }: ActionContext<State, any>,
    { params }: { params: any }
  ) {
    return new Promise((resolve, reject) => {
      excel(params)
        .then((response: ApiResponse) => {
          const { data } = response;

          console.log(data);
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  editAdvertise(
    { commit, state }: ActionContext<State, any>,
    adBean: {
      adRank: 0;
      advImg: "";
      createTime: "";
      firstTitle: "";
      id: "";
      outlink: "";
      secondTitle: "";
    }
  ) {
    return new Promise((resolve, reject) => {
      editAdvertise(adBean)
        .then((response: ApiResponse) => {
          const { data } = response;
          if (response.code == 200) {
            ElMessage.success({
              message: "修改成功",
            });
          }
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  addAdertise(
    { commit, state }: ActionContext<State, any>,
    adBean: {
      adRank: 0;
      advImg: "";
      createTime: "";
      firstTitle: "";
      outlink: "";
      secondTitle: "";
    }
  ) {
    return new Promise((resolve, reject) => {
      addAdvertise(adBean)
        .then((response: ApiResponse) => {
          const { data } = response;
          if (response.code == 200) {
            ElMessage.success({
              message: "修改成功",
            });
          }
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  deleteAd({ commit }: ActionContext<State, any>, { id }: { id: string }) {
    return new Promise((resolve, reject) => {
      deleteAd({ id: id })
        .then((response: ApiResponse) => {
          const { data } = response;

          if (data == 1) {
            ElMessage.success({
              message: "删除成功",
            });
          }

          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  addNotice(
    { commit, state }: ActionContext<State, any>,
    adBean: {
      title: "";
      info: "";
      signOrder: 1;
    }
  ) {
    return new Promise((resolve, reject) => {
      addNotice(adBean)
        .then((response: ApiResponse) => {
          const { data } = response;
          if (response.code == 200) {
            ElMessage.success({
              message: "添加成功",
            });
          }
          resolve(data);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit }: ActionContext<State, any>) {
    return new Promise<void>((resolve) => {
      removeToken(); // must remove token first
      resetRouter();
      commit("game/RESET_STATE", null, { root: true }); // 调用 game 模块的 mutation
      commit("RESET_STATE");
      resolve();
    });
  },

  // remove token
  resetToken({ commit }: ActionContext<State, any>) {
    return new Promise<void>((resolve) => {
      removeToken(); // must remove token first
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
